import React from 'react';

// Tento "Z" wordmark used during the submitting state. Shared between
// the wizard's SubmittingOverlay and anywhere else a spinning brand mark
// is needed.
export const TentoZ: React.FC<{ className?: string }> = ({ className }) => (
  <svg width="60" height="59" viewBox="0 0 60 59" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M47.234 46.4483H21.794L47.234 21.4315V46.4483ZM12.766 12.5537H38.206L12.766 37.5705V12.5537ZM47.91 0H12.372V12.1662H0V47.1111C0 53.6662 5.424 59 12.092 59H47.628V46.8338H60V11.8889C60 5.33378 54.576 0 47.91 0Z"
      fill="#0D0D0D"
    />
  </svg>
);
